// extracted by mini-css-extract-plugin
export var button = "_br-0";
export var icon = "_br-1";